<template>
  <div class="p-grid irinox-form after-sales spare-parts shopping-cart">
    <div class="p-col-12 after-sales-model-details-body p-py-1">
      <p style="margin-top: 0rem; margin-bottom: 0;"><img src="/assets/irinox/icons/arrow_back.svg" alt="Back"
          @click="$functions.historyBack()" /> {{ $t('spareParts.cart.title') }}</p>
    </div>

    <div v-if="cart?.length==0" class="p-col-12 p-d-flex p-jc-center p-py-6">
      <div style="max-width: 600px; gap: 20px;" class="p-text-center p-d-flex p-flex-column p-ai-center" >
        <div>
          <img src="/assets/irinox/icons/shopping_cart_big.svg" alt="Empty Cart"/>
        </div>
        <h2>{{ $t('spareParts.cart.empty_title') }}</h2>
        <h3>{{ $t('spareParts.cart.empty_subtitle') }}</h3>
        <Button :label="$t('spareParts.cart.button_add_code')" class="p-button-outlined p-mt-4" @click="dialog.manualAdd=true"/>
        <Button :label="$t('spareParts.cart.button_go_to_spareparts')" class="p-mt-2" @click="$router.push({ path: '/after-sales' })"/>
      </div>
    </div>

    <div v-else class="p-col-12 p-py-4">
      <TabView v-model:activeIndex="activeTab">
        <TabPanel :header="$t('spareParts.cart.tab_items')">
          <div class="p-grid">
            <div class="p-col-12">
              <ShoppingCartTable />
            </div>
            <div class="p-col-12 p-md-6 p-pr-4">
              <Button :label="$t('spareParts.cart.button_add_code')" class="p-button-outlined p-ml-4" @click="dialog.manualAdd=true"/>
            </div>
            <div class="p-col-12 p-md-6 totals">
              <div class="p-d-flex p-jc-end p-ai-center p-pr-4">
                <div class="">{{ $t('spareParts.cart.total_price') }}</div>
                <div class="p-text-right" style="width: 180px;">
                  {{ totalPrice ? $n(totalPrice, 'money') : '-' }}
                  {{ totalPrice ? (cart[0].currency === 'EUR' ? '€ ' : '$ ') : '' }}
                </div>
              </div>
              <div class="p-d-flex p-jc-end p-ai-center p-pr-4">
                <div class="">{{ $t('spareParts.cart.total_quantity') }}</div>
                <div class="p-text-right" style="width: 180px;">
                  {{ totalItems }}
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-6 p-d-flex p-flex-column p-jc-center">
              <label for="notes" class="totals p-ml-4">{{ $t('spareParts.cart.notes') }}</label>
              <Textarea id="notes" v-model="notes" rows="4" :placeholder="$t('spareParts.cart.notes_ph')" class="p-ml-4"/>
            </div>
            <div class="p-col-12 p-md-6 p-d-flex p-flex-column p-ai-end ">
              <div class="disclaimer p-pr-4">{{ $t('spareParts.cart.disclaimer') }}</div>
              <Button :label="$t('spareParts.cart.next_button')" class="p-mt-4 p-mr-4" @click="activeTab=1"/> 
            </div>
          </div>
        </TabPanel>
        <TabPanel :header="$t('spareParts.cart.tab_send')">
          <ShoppingCartSend :comment="notes"/>
        </TabPanel>
      </TabView>
    </div>
  </div>

  <ShoppingCartManualAdd :visible="dialog.manualAdd"  @update:visible="dialog.manualAdd = $event"/>
</template>

<script>
import { mapGetters } from 'vuex';
import AfterSalesService from '../../../service/AfterSalesService';
import AccountService from '../../../service/AccountService';
import ShoppingCartManualAdd from './ShoppingCartManualAdd.vue';
import ShoppingCartTable from './ShoppingCartTable.vue';
import ShoppingCartSend from './ShoppingCartSend.vue';

export default {
  components: {
    ShoppingCartManualAdd,
    ShoppingCartTable,
    ShoppingCartSend,
  },
  data() {
    return {
      dialog: {
        manualAdd: false,
        error: false,
      },
      notes: null,
      activeTab: 0,
      userdata: null,

    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      role: 'userdata/role',
      cart: 'afterSales/cart'
    }),
    totalPrice() {
      let total = 0;
      this.cart.forEach(item => {
        if(item.price && item.quantity) {
          total += item.price * item.quantity;
        }
      });
      return total;
    },
    totalItems() {
      let total = 0;
      this.cart.forEach(item => {
        if(item.quantity) {
          total += item.quantity;
        }
      });
      return total;
    }
  },
  created() {
    this.afterSalesService = new AfterSalesService();
    this.accountService = new AccountService();
  },
  mounted() {
    this.loadCart();
  },
  methods: {
    loadCart() {
      this.afterSalesService.getSpCart(this.personaltoken)
        .then((data) => {
          if (data.code === "200") {
            this.$store.commit('afterSales/cart', data.body);
          } else {
            this.$store.commit('afterSales/cart', []);
            console.error(JSON.stringify(data));
          }
        })
        .catch(error => {
          this.$store.commit('afterSales/cart', []);
          console.error("ERROR " + error);
        });
    },
  }
}
</script>

<style scoped>
</style>